import React, { useEffect, useState } from "react";
import { Moon, Sun, Sunrise, Sunset, CloudSun } from "lucide-react";
import { api } from "../lib/api";

const ICONS = { Subuh: Sunrise, Dzuhur: Sun, Ashar: CloudSun, Maghrib: Sunset, Isya: Moon };
const fmtCountdown = (s) => {
  if (s == null || s < 0) return "";
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};

export function PrayerWidget() {
  const [data, setData] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [clock, setClock] = useState("");

  useEffect(() => {
    let active = true;
    const load = () => api.get("/prayer/today").then((r) => { if (active) { setData(r.data); setCountdown(r.data?.next?.in_seconds ?? null); } }).catch(() => {});
    load();
    const reload = setInterval(load, 5 * 60 * 1000);
    return () => { active = false; clearInterval(reload); };
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      setCountdown((c) => (c == null ? c : Math.max(0, c - 1)));
      setClock(new Date().toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "Asia/Jakarta" }));
    }, 1000);
    return () => clearInterval(t);
  }, []);

  if (!data || data.enabled === false) return null;
  const dateLabel = new Date(data.date + "T00:00:00").toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="rounded-xl bg-cocoa-dark text-ivory p-4 lg:p-5 shadow-sm" data-testid="prayer-widget">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[11px] text-ivory/60 uppercase tracking-wide">Jadwal Sholat · {data.region}</div>
          <div className="font-heading text-lg font-bold leading-tight">{dateLabel}</div>
          <div className="text-xs text-ivory/70">{clock || data.now} WIB</div>
        </div>
        {data.available && data.next?.time && (
          <div className="text-right" data-testid="prayer-next">
            <div className="text-[11px] text-ivory/60">Berikutnya · {data.next.name}{data.next.date && data.next.date !== data.date ? " (besok)" : ""}</div>
            <div className="font-heading text-2xl font-bold text-amber-300 tabular-nums">{fmtCountdown(countdown)}</div>
            <div className="text-xs text-ivory/70">pukul {data.next.time} WIB</div>
          </div>
        )}
      </div>

      {!data.available ? (
        <div className="mt-3 text-sm text-amber-200 bg-ivory/10 rounded-lg px-3 py-2" data-testid="prayer-unavailable">Jadwal belum tersedia untuk hari ini.</div>
      ) : (
        <div className="mt-3 grid grid-cols-5 gap-1.5">
          {["Subuh", "Dzuhur", "Ashar", "Maghrib", "Isya"].map((name) => {
            const Icon = ICONS[name] || Sun;
            const isNext = data.next?.name === name && (!data.next.date || data.next.date === data.date);
            return (
              <div key={name} data-testid={`prayer-slot-${name}`} className={`rounded-lg px-1.5 py-2 text-center ${isNext ? "bg-amber-400 text-cocoa-dark" : "bg-ivory/10"}`}>
                <Icon className={`w-4 h-4 mx-auto mb-1 ${isNext ? "text-cocoa-dark" : "text-ivory/70"}`} />
                <div className="text-[10px] font-medium">{name}</div>
                <div className="text-sm font-bold tabular-nums">{data.times[name]}</div>
              </div>
            );
          })}
        </div>
      )}
      <div className="mt-2 text-[10px] text-ivory/40">Sumber: {data.source || "-"} · {data.timezone}{data.manual ? " · input manual" : ""}</div>
    </div>
  );
}
